const state = {
    scroller: {
        category: "",
        location: "",
        displayOrder: "",
        position: 0
    }
}

const getters = {
    scroller: state => state.scroller
}

const mutations = {
    UPDATE_SCROLLER(state, payload) {
        state.scroller = payload;
    }
}

const actions = {
    saveScroller({ commit }, params) {
        commit('UPDATE_SCROLLER', params);
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}